module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7xDjX"))).then(() => module.bundle.root('iDabs'));